export default __webpack_public_path__ + "static/media/infra.da546e04.webp";